import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllUnitsUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllUnits/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllUnitsUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllUnitsUser;
};


const setActiveUnits = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setUnitsActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllUnitsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Units  - ',response);


    return AllUnitsUser;
};



const setDeletedUnits = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setUnitsDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllUnitsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Units  - ',response);


    return AllUnitsUser;
};




const setUpdateUnits = async (dataUnitsUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setUnitsUpdate/'),{
        dataUnitsUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllUnitsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Units  - ',dataUnitsUpdate,response);


    return AllUnitsUser;
};


const setSaveNewUnits = async (dataUnitsUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewUnits/'),{
        dataUnitsUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllUnitsUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Units  - ',response);


    return AllUnitsUser;
};

Mock.onGet('/api/reference/getAllUnits').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllUnitsUser = await getAllUnitsUser();
    // console.log('С сервера пришло - ', AllUnitsUser);

    // if (!AllUnitsUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllUnitsUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllUnitsUser,
    ]


})


Mock.onPost('/api/reference/setActiveUnits').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllUnitsUser = await setActiveUnits(id,val);

    // if (!AllUnitsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllUnitsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllUnitsUser,
    ]


})

Mock.onPost('/api/reference/setDeletedUnits').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllUnitsUser = await setDeletedUnits(id,val);

    // if (!AllUnitsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllUnitsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllUnitsUser,
    ]


})


Mock.onPost('/api/reference/setUpdateUnits').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataUnitsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Units = await setUpdateUnits(dataUnitsUpdate);

    // console.log('Серовер вернул данные ',AllUnitsUser);

    // if (!Units) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Units) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Units,
    ]


})


Mock.onPost('/api/reference/setSaveNewUnits').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataUnitsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Units = await setSaveNewUnits(dataUnitsUpdate);

    // console.log('Серовер вернул данные ',AllUnitsUser);

    // if (!Units) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Units) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Units,
    ]
})